import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7 17.596H3c-.6 0-1-.39-1-.977V2.933c0-.587.4-.978 1-.978h4c.6 0 1-.39 1-.977S7.6 0 7 0H3C1.3 0 0 1.271 0 2.933v13.686c0 1.662 1.3 2.933 3 2.933h4c.6 0 1-.391 1-.978 0-.586-.4-.978-1-.978m12.9-7.429c.1-.195.1-.489 0-.782-.1-.098-.1-.195-.2-.293l-5-4.888a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.368l3.3 3.226H7c-.6 0-1 .392-1 .978 0 .587.4.978 1 .978h9.6l-3.3 3.226a.93.93 0 0 0 0 1.368c.2.196.5.294.7.294s.5-.098.7-.294l5-4.888c.1-.097.2-.195.2-.293"
    }, null, -1)
  ]))]))
}
export default { render: render }